const mtestOptionCases = {
  REFERRAL: 'REFERRAL',
  RESULTS: 'RESULTS',
  RESULTS_VIEWER: 'RESULTS_VIEWER',
  RESULTS_VIEWER_URL: 'RESULTS_VIEWER_URL',
  IMAGE: 'IMAGE',
  IC: 'IC'
};

const mtestOptionsActions = {
  REFERRAL: 'HAS_REFERRAL',
  RESULTS: 'HAS_RESULTS',
  IC: 'HAS_INFORMED_CONSENT',
  RESULTS_VIEWER: 'HAS_RESULTS_VIEWER',
  RESULTS_VIEWER_URL: 'HAS_RESULTS_VIEWER_URL',
  IMAGE: 'HAS_IMAGES_VIEWER'
};

const mtestOptionPermission = {
  REFERRAL: 'patient_requests:download_proof',
  RESULTS: 'patient_requests:download_results',
  IC: 'patient_requests:download_ic',
  RESULTS_VIEWER: 'patient_requests:download_viewer_results',
  RESULTS_VIEWER_URL: 'patient_requests:download_viewer_results',
  IMAGE: 'patient_requests:download_viewer_images'
};

const mtestOptionValues = {
  REFERRAL: {
    id: -1,
    name: 'SI_REFERRAL',
    type: mtestOptionCases.REFERRAL
  },
  RESULTS: {
    id: -2,
    name: 'SI_REPORT',
    type: mtestOptionCases.RESULTS
  },
  RESULTS_VIEWER: {
    id: -3,
    name: 'SI_RESULTS',
    type: mtestOptionCases.RESULTS_VIEWER
  },
  RESULTS_VIEWER_URL: {
    id: -4,
    name: 'SI_RESULTS',
    type: mtestOptionCases.RESULTS_VIEWER_URL
  },
  IMAGE: {
    id: -5,
    name: 'SI_MEDICAL_IMAGES',
    type: mtestOptionCases.IMAGE
  }
};

const mtestRequestTypeIds = {
  TREATMENT_REQUEST: 6
};

const mtestTypeCases = {
  SCHEDULED: 1,
  CAN_SCHEDULE: 2,
  CANT_SCHEDULE: 3
};

export {
  mtestOptionValues,
  mtestOptionCases,
  mtestRequestTypeIds,
  mtestTypeCases,
  mtestOptionsActions,
  mtestOptionPermission
};
